import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { HomeUsesFailure, HomeUsesRequest, HomeUsesSuccess } from './actions';
import { HomeUsesService } from './service';
import { AppState } from '@store/app.state';
import { select, Store } from '@ngrx/store';
import { getData } from './selectors';

@Injectable()
export class HomeUsesEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store<AppState>);
  private readonly homeUsesService = inject(HomeUsesService);

  homeUses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HomeUsesRequest),
      withLatestFrom(this.store.pipe(select(getData))),
      switchMap(([{ parameters }, data]) => {
        if (!data?.length) {
          return this.homeUsesService.homeUses(parameters).pipe(
            map(data => HomeUsesSuccess({ data })),
            catchError(error => of(HomeUsesFailure({ error })))
          );
        }
        return of(HomeUsesSuccess({ data }));
      })
    )
  );

}
